import axios from 'axios';
import { useRBACStore } from '../../../plugins/RBACPlugin'; 
import { apiPrefixes, exemptedAPIPrefixRoutes, forceOrgPrefixPagesRoutes, withAPIPrefixRoutes, profile_types, modules } from '../../components/common/variables/static_variables';
import { yearCalendarClasses } from '@mui/x-date-pickers';

const instance = axios.create({});

const getPrefix = (config, match, apiBase, path = '', profile_type) => {

    let selectedPrefix = '';

    for (const prefix of apiPrefixes) {
      if (prefix == 'org') {
        const forceOrgPrefixPage = forceOrgPrefixPagesRoutes.includes(window.location.pathname);
        const isBusiness = profile_type == profile_types.BUSINESS;
        // const moduleHasPrefix = assignedModules.BUSINESS.find(module => module == module_path[0]);

        if (forceOrgPrefixPage || isBusiness) {
            selectedPrefix = prefix;
            break;
        }
      } 
      else if (prefix == 'assigned') {
        const isIndividual = profile_type == profile_types.INDIVIDUAL;
        const module_path = config.url.split('/api/v1/')[1].split("/");

        const isDashboard = module_path[0] == modules.DASHBOARD
        if (isDashboard && isIndividual) {
            selectedPrefix = prefix;
            break;
        }
      } 
      else if (prefix == 'all') {
        const isPortEmployee = profile_type == profile_types.PORT_EMPLOYEE;
        const module_path = config.url.split('/api/v1/')[1].split("/");

        const isDashboard = module_path[0] == modules.DASHBOARD
        if (isDashboard && isPortEmployee) {
            selectedPrefix = prefix;
            break;
        }
      }
    }

    console.log("selectedPrefix bbbb", selectedPrefix);

    return selectedPrefix;
}

// Request interceptor to modify URLs
instance.interceptors.request.use((config) => {
    const { currentProfile } = useRBACStore.getState();
    let profile_type = currentProfile?.profileType;

    // Regex to find `/api/v1/` and inject prefix after
    const pattern = /(\/api\/v1)(\/[^?]*)?/;

    if (config.url && pattern.test(config.url)) {
        config.url = config.url.replace(pattern, (match, apiBase, path = '') => {
            console.log("config.url origin", config.url);
            console.log("config.url match", match);

            const isExempted = exemptedAPIPrefixRoutes.includes(path);

            // add prefix
            if (!isExempted) {
                let prefix = getPrefix(config, match, apiBase, path, profile_type);
                console.log("prefix bbbb", prefix);

                return `${apiBase}/${prefix}${path}`;
            }

            return `${apiBase}${path}`;
        });
    }

    console.log("config.url updated", config.url);

    return config;

}, (error) => {
  return Promise.reject(error);
});

export default instance;
